import { render, staticRenderFns } from "./SphereViewerDialog.vue?vue&type=template&id=1a83a77e"
import script from "./SphereViewerDialog.vue?vue&type=script&lang=ts"
export * from "./SphereViewerDialog.vue?vue&type=script&lang=ts"
import style0 from "./SphereViewerDialog.vue?vue&type=style&index=0&id=1a83a77e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports